import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const users_group: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        stroke={iconColor}
        d="M13.6504,11.7456 C16.1704,13.1926 17.2904,15.5496 17.5004,18.5006
    L6.5004,18.5006 C6.5494,15.4746 7.8824,13.1426 10.2994,11.7506 M9.5303,9.8784 C9.6803,11.3634 10.6863,12.5014
    12.0003,12.5014 C13.3133,12.5014 14.3193,11.3634 14.4693,9.8784 M13.5303,7.1221 C13.1123,6.7361 12.5893,6.4991
    12.0003,6.4991 C11.4103,6.4991 10.8873,6.7361 10.4693,7.1221 M16,4.499 C14.687,4.499 13.681,5.638 13.53,7.122
    C14.124,7.669 14.5,8.523 14.5,9.501 C14.5,9.63 14.482,9.753 14.47,9.878 C14.888,10.264 15.411,10.501 16,10.501
    C17.425,10.501 18.5,9.168 18.5,7.501 C18.5,5.833 17.425,4.499 16,4.499 Z M14.4697,9.8784 C14.4827,9.7534
    14.4997,9.6304 14.4997,9.5014 C14.4997,8.5234 14.1237,7.6694 13.5307,7.1224 M10.4697,7.1221 C10.3197,5.6381
    9.3137,4.4991 7.9997,4.4991 C6.5757,4.4991 5.4997,5.8331 5.4997,7.5011 C5.4997,9.1681 6.5757,10.5011 7.9997,10.5011
    C8.5897,10.5011 9.1127,10.2641 9.5307,9.8781 C9.5177,9.7531 9.4997,9.6301 9.4997,9.5011 C9.4997,8.5231
    9.8767,7.6691
    10.4697,7.1221 Z M10.4697,7.1221 C9.8767,7.6691 9.4997,8.5231 9.4997,9.5011 C9.4997,9.6301 9.5177,9.7531
    9.5307,9.8781
    M17.6504,9.7441 C20.1704,11.1911 21.2904,13.5491 21.5004,16.5001 L17.1884,16.5001 M6.7422,16.4971 L2.5002,16.4971
    C2.5502,13.4711 3.8822,11.1391 6.3002,9.7471"
      />
    </svg>
  );
};
